














































































































































import { Component, Vue } from "vue-property-decorator";
import AuthModule from "@/store/auth";
import RestaurantModule from "@/store/restaurant";
import TokenUtil from "@/utils/TokenUtil";
import { EditStatus, edDays } from "@/types";

@Component
export default class RResutaurantInfo extends Vue {
  private get me() {
    return AuthModule.me;
  }

  private get editStatus() {
    return EditStatus;
  }

  private get currentEditStatus() {
    return RestaurantModule.editStatus;
  }

  private get edDays() {
    return edDays;
  }

  private openEditForm() {
    RestaurantModule.commitEditStatus(EditStatus.Edit);
  }

  private logout() {
    TokenUtil.removeToken();
    AuthModule.commitMe(null);
    this.$router.push("/");
  }

  private formatDate(day: Date) {
    const formatDay = new Date(day);
    const year = formatDay.getFullYear();
    const month = formatDay.getMonth() + 1;
    const d = formatDay.getDate();
    return `${year}年${month}月${d}日`;
  }
}
